<script lang="ts">
  import { twMerge } from "tailwind-merge";
  export let tag: keyof HTMLElementTagNameMap = "div";
  export let isCentered: boolean = true;
</script>

<svelte:element
  this={tag}
  class={twMerge(
    isCentered ? "mx-auto" : "",
    "prose-lg max-w-screen-lg text-white prose-p:text-body-base prose-blockquote:wah-body-base prose-blockquote:italic prose-a:underline ",
    $$props.class,
  )}
>
  <slot />
</svelte:element>
